import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError } from 'rxjs';
import { FORulesGeneral } from 'src/app/models/fo-rules-general';

@Injectable({
  providedIn: 'root'
})
export class ForulesService {

  readonly foRulesAPi = '/api/fomaintenance/';

  constructor(private http: HttpClient) { }

  getFORules(): Observable<FORulesGeneral[]>{
    const url = this.foRulesAPi + 'rules';
    return this.http.get<FORulesGeneral[]>(url).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  editFORules(foRules: FORulesGeneral){
    const url = this.foRulesAPi +  'rules';
    return this.http.put<FORulesGeneral>(url, foRules).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }
}
